import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ItineraryModel} from "../models/itinerary.model";

@Injectable({providedIn: 'root'})
export class ItinerariesHttpService {

  private base_url = `/itineraries`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getItineraries(ids?: string[]): Observable<ItineraryModel[]> {
    return this.http
      .get<ItineraryModel[]>(this.base_url, {
        params: {
          ids: ids
        }
      });
  }

}
